
class VirtualBackend {
  constructor() {
    this.storageKey = 'cat_blog_data_v2';
    this.currentUserKey = 'cat_blog_current_user';
    this.initializeData();
  }

initializeData() {
  if (!localStorage.getItem(this.storageKey)) {
    const defaultData = {
      posts: [],
      users: [
        {
          id: 1,
          username: 'catlover',
          password: 'password123',
          name: '猫咪守护者',
          email: 'cat@example.com',
          avatar: 'https://images.unsplash.com/photo-1533738363-b7f9aef128ce?w=150&h=150&fit=crop&crop=face',
          coverImage: 'https://images.unsplash.com/photo-1513360371669-4adf3dd7dff8?w=1200&h=300&fit=crop',
          bio: '资深猫奴，热爱分享猫咪知识，家有3只喵星人',
          role: 'admin',
          joinedAt: '2024-01-15',
          location: '北京',
          catCount: 3,
          catNames: '橘子、奶茶、布丁'
        }
        // 只保留一个初始用户，其他用户在注册时创建
      ],
      comments: [],
      likes: [],
      bookmarks: [],
      siteConfig: this.generateSiteConfig()
    };
    localStorage.setItem(this.storageKey, JSON.stringify(defaultData));
  }
}

  generateDefaultPosts() {
    const categories = ['日常趣事', '养护知识', '行为解读', '饮食健康', '新手指南', '健康护理', '猫咪玩具', '日常护理'];
    
    // 替换为稳定可访问的猫咪图片链接（Unsplash 免费可商用）
    const coverImages = [
      // 高清猫咪图片 - 确保所有链接均可正常访问
      'https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba?w=800&auto=format&fit=crop', // 橘猫
      'https://tse2-mm.cn.bing.net/th/id/OIP-C.Zy3t3Tvs6vC6JGnMRQYvPAHaE7?w=276&h=184&c=7&r=0&o=7&dpr=2&pid=1.7&rm=3', // 黑猫
      'https://images.unsplash.com/photo-1548247416-ec66f4900b2e?w=800&auto=format&fit=crop', // 奶猫
      'https://images.unsplash.com/photo-1517331156700-3c241d2b4d83?w=800&auto=format&fit=crop', // 加菲猫
      'https://images.unsplash.com/photo-1608848461950-0fe51dfc41cb?w=800&auto=format&fit=crop', // 田园猫
      '/images/cat1.jpg',
       '/images/cat2.jpg'// 多猫合照
    ];
    
    return Array.from({ length: 20 }, (_, index) => {
      const category = categories[Math.floor(Math.random() * categories.length)];
      const daysAgo = Math.floor(Math.random() * 30);
      const publishDate = new Date(Date.now() - daysAgo * 24 * 60 * 60 * 1000);
      const imageIndex = index % coverImages.length;
      
      return {
        id: index + 1,
        title: this.generatePostTitle(category),
        excerpt: this.generateExcerpt(),
        content: this.generateContent(),
        coverImage: coverImages[imageIndex], // 使用替换后的稳定图片链接
        category: category,
        tags: this.generateTags(category),
        authorId: 1,
        views: Math.floor(Math.random() * 1000) + 100,
        likes: Math.floor(Math.random() * 200) + 10,
        comments: Math.floor(Math.random() * 50),
        featured: index < 3,
        publishDate: publishDate.toISOString(),
        updatedAt: publishDate.toISOString()
      };
    });
  }

  generatePostTitle(category) {
    const titles = {
      '日常趣事': [
        '我家猫咪的搞笑日常',
        '猫咪的那些可爱瞬间',
        '喵星人的迷惑行为大赏',
        '今天猫咪又做了什么？'
      ],
      '养护知识': [
        '猫咪护理全攻略',
        '如何正确给猫咪洗澡',
        '猫咪毛发护理指南',
        '日常养护注意事项'
      ],
      '行为解读': [
        '猫咪尾巴语言解读',
        '为什么猫咪会踩奶？',
        '猫咪叫声的含义',
        '猫咪的行为心理学'
      ],
      '饮食健康': [
        '猫咪健康饮食指南',
        '自制猫饭教程',
        '如何选择猫粮',
        '猫咪营养需求分析'
      ],
      '新手指南': [
        '第一次养猫必备',
        '新手铲屎官指南',
        '接猫前准备工作',
        '猫咪用品选购指南'
      ],
      '健康护理': [
        '常见猫咪疾病预防',
        '定期体检的重要性',
        '猫咪疫苗全攻略',
        '老年猫护理要点'
      ],
      '猫咪玩具': [
        'DIY猫咪玩具教程',
        '如何选择合适玩具',
        '互动玩具推荐',
        '猫咪玩具安全性'
      ],
      '日常护理': [
        '猫咪剪指甲教程',
        '耳朵清洁方法',
        '牙齿护理指南',
        '日常检查清单'
      ]
    };
    
    const categoryTitles = titles[category] || ['有趣的猫咪知识'];
    return categoryTitles[Math.floor(Math.random() * categoryTitles.length)];
  }

  generateExcerpt() {
    const excerpts = [
      '分享猫咪的有趣行为和实用知识，让你更了解你的喵星人',
      '专业的猫咪护理指南，帮助你成为更好的猫奴',
      '实用的养猫技巧和经验分享，让养猫变得更简单',
      '深入了解猫咪的行为和心理，建立更好的人猫关系',
      '科学的喂养和护理方法，确保猫咪健康快乐'
    ];
    return excerpts[Math.floor(Math.random() * excerpts.length)];
  }

  generateContent() {
    return `
      <h2>第一部分：猫咪的基本知识</h2>
      <p>猫咪是很有趣的动物，它们有着自己独特的行为模式和沟通方式。</p>
      
      <h3>1.1 猫咪的习性</h3>
      <p>了解猫咪的习性对于建立良好的关系非常重要。</p>
      
      <h2>第二部分：实用技巧</h2>
      <p>这里分享一些实用的猫咪护理技巧。</p>
      
      <h3>2.1 日常护理</h3>
      <p>定期的护理可以让猫咪保持健康和舒适。</p>
      
      <h2>第三部分：经验分享</h2>
      <p>分享一些个人经验和心得体会。</p>
    `;
  }

  generateTags(category) {
    const tagMap = {
      '日常趣事': ['搞笑', '日常', '可爱', '萌宠'],
      '养护知识': ['护理', '清洁', '美容', '保养'],
      '行为解读': ['行为', '心理', '沟通', '习惯'],
      '饮食健康': ['饮食', '营养', '健康', '喂养'],
      '新手指南': ['新手', '入门', '准备', '基础'],
      '健康护理': ['健康', '医疗', '预防', '护理'],
      '猫咪玩具': ['玩具', '娱乐', '互动', '玩耍'],
      '日常护理': ['日常', '护理', '清洁', '检查']
    };
    return tagMap[category] || ['猫咪', '知识'];
  }

  generateSiteConfig() {
    return {
      siteName: '喵星人日记',
      siteDescription: '记录与猫咪共度的美好时光，分享养猫心得和科学知识',
      siteLogo: '🐱',
      siteKeywords: ['猫咪', '养猫', '宠物', '猫咪护理', '猫咪训练'],
      contactEmail: 'hello@catdiary.com',
      socialLinks: {
        weibo: 'https://weibo.com/catdiary',
        bilibili: 'https://space.bilibili.com/catdiary',
        github: 'https://github.com/catdiary'
      },
      announcement: {
        enabled: true,
        content: '🎉 欢迎来到喵星人日记！分享你的猫咪故事，赢取精美猫粮奖品！',
        type: 'info'
      },
      featuredPostsCount: 3,
      postsPerPage: 12,
      commentsEnabled: true,
      registrationEnabled: true,
      theme: 'light',
      createdAt: new Date().toISOString()
    };
  }

  getData() {
    return JSON.parse(localStorage.getItem(this.storageKey) || '{}');
  }

  saveData(data) {
    localStorage.setItem(this.storageKey, JSON.stringify(data));
  }

  delay(ms = 300) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  // 分类表情映射
  getCategoryEmoji(category) {
    const emojiMap = {
      '日常趣事': '😺',
      '养护知识': '📚',
      '行为解读': '🔍',
      '饮食健康': '🍲',
      '新手指南': '🐱',
      '健康护理': '❤️',
      '猫咪玩具': '🎮',
      '日常护理': '🛁',
      '猫咪品种': '🐈',
      '猫咪训练': '🎯'
    };
    return emojiMap[category] || '🐾';
  }

  // API 方法
  api = {
    register: async (userData) => {
      await this.delay(500);
      const data = this.getData();
      
      // 检查用户名是否已存在
      const existingUser = data.users.find(user => 
        user.username === userData.username || user.email === userData.email
      );
      
      if (existingUser) {
        return {
          success: false,
          message: existingUser.username === userData.username 
            ? '用户名已存在' 
            : '邮箱已注册'
        };
      }
      
      // 创建新用户
      const newUser = {
        id: Date.now(),
        username: userData.username,
        password: userData.password, // 注意：实际应用中密码应该加密存储
        name: userData.name || userData.username,
        email: userData.email,
        avatar: 'https://images.unsplash.com/photo-1561948955-570b270e7c36?w=150&h=150&fit=crop&crop=face', // 默认头像
        coverImage: 'https://images.unsplash.com/photo-1513360371669-4adf3dd7dff8?w=1200&h=300&fit=crop', // 默认封面
        bio: '欢迎新成员！快来分享你的猫咪故事吧～',
        role: 'user',
        joinedAt: new Date().toISOString().split('T')[0],
        location: '',
        catCount: 0,
        catNames: '暂无'
      };
      
      data.users.push(newUser);
      this.saveData(data);
      
      // 自动登录
      const { password, ...userWithoutPassword } = newUser;
      localStorage.setItem(this.currentUserKey, JSON.stringify(userWithoutPassword));
      
      return {
        success: true,
        data: userWithoutPassword,
        message: '注册成功，已自动登录'
      };
    },

    login: async (credentials) => {
      await this.delay(400);
      const data = this.getData();
      
      // 查找用户（支持用户名或邮箱登录）
      const user = data.users.find(user => 
        (user.username === credentials.usernameOrEmail || user.email === credentials.usernameOrEmail) &&
        user.password === credentials.password
      );
      
      if (user) {
        // 移除密码字段后存储用户信息
        const { password, ...userWithoutPassword } = user;
        localStorage.setItem(this.currentUserKey, JSON.stringify(userWithoutPassword));
        
        return {
          success: true,
          data: userWithoutPassword,
          message: '登录成功'
        };
      }
      
      return {
        success: false,
        message: '用户名或密码错误'
      };
    },

    logout: async () => {
      await this.delay(200);
      localStorage.removeItem(this.currentUserKey);
      return {
        success: true,
        message: '已退出登录'
      };
    },

// 在 mockData.js 的 api 对象中
getCurrentUser: async () => {
  await this.delay(200);
  const currentUserStr = localStorage.getItem(this.currentUserKey);
  
  if (!currentUserStr) {
    return {
      success: false,
      message: '用户未登录'
    };
  }
  
  try {
    const currentUser = JSON.parse(currentUserStr);
    const data = this.getData();
    
    // 根据 localStorage 中的用户ID查找用户
    const user = data.users?.find(u => u.id === currentUser.id);
    
    if (user) {
      // 获取用户统计数据
      const userPosts = data.posts?.filter(p => p.authorId === user.id) || [];
      const userLikes = data.likes?.filter(l => l.userId === user.id) || [];
      const userBookmarks = data.bookmarks?.filter(b => b.userId === user.id) || [];
      
      // 移除密码字段
      const { password, ...userWithoutPassword } = user;
      
      return {
        success: true,
        data: {
          ...userWithoutPassword,
          stats: {
            posts: userPosts.length,
            likes: userLikes.length,
            bookmarks: userBookmarks.length,
            totalViews: userPosts.reduce((sum, post) => sum + (post.views || 0), 0)
          }
        }
      };
    } else {
      // 用户不存在于数据库中，清除本地存储
      localStorage.removeItem(this.currentUserKey);
      return {
        success: false,
        message: '用户信息已过期'
      };
    }
  } catch (error) {
    console.error('解析用户信息失败:', error);
    localStorage.removeItem(this.currentUserKey);
    return {
      success: false,
      message: '用户信息无效'
    };
  }
},

    checkAuth: async () => {
      await this.delay(100);
      const currentUserStr = localStorage.getItem(this.currentUserKey);
      
      if (currentUserStr) {
        try {
          const currentUser = JSON.parse(currentUserStr);
          return {
            success: true,
            data: currentUser,
            message: '用户已登录'
          };
        } catch (error) {
          localStorage.removeItem(this.currentUserKey);
          return {
            success: false,
            message: '登录信息无效'
          };
        }
      }
      
      return {
        success: false,
        message: '用户未登录'
      };
    },


    // 文章相关
    getPosts: async (params = {}) => {
      await this.delay(300);
      const data = this.getData();
      let posts = [...(data.posts || [])];
      
      // 排序
      if (params.sort === 'popular') {
        posts.sort((a, b) => b.views - a.views);
      } else if (params.sort === 'latest') {
        posts.sort((a, b) => new Date(b.publishDate) - new Date(a.publishDate));
      } else if (params.sort === 'likes') {
        posts.sort((a, b) => b.likes - a.likes);
      }
      
      // 筛选
      if (params.category) {
        posts = posts.filter(post => post.category === params.category);
      }
      if (params.search) {
        const search = params.search.toLowerCase();
        posts = posts.filter(post => 
          post.title.toLowerCase().includes(search) ||
          post.excerpt.toLowerCase().includes(search) ||
          post.tags?.some(tag => tag.toLowerCase().includes(search))
        );
      }
      
      // 分页
      const page = params.page || 1;
      const limit = params.limit || 10;
      const start = (page - 1) * limit;
      const total = posts.length;
      
      return {
        success: true,
        data: posts.slice(start, start + limit),
        pagination: {
          page,
          limit,
          total,
          pages: Math.ceil(total / limit)
        }
      };
    },

    getPost: async (id) => {
      await this.delay(200);
      const data = this.getData();
      const post = data.posts?.find(p => p.id === parseInt(id));
      
      if (post) {
        // 更新浏览量
        post.views = (post.views || 0) + 1;
        // 获取作者信息
        const author = data.users?.find(u => u.id === post.authorId);
        // 获取评论
        const comments = data.comments?.filter(c => c.postId === parseInt(id)) || [];
        
        this.saveData(data);
        
        return {
          success: true,
          data: {
            ...post,
            author,
            comments
          }
        };
      }
      
      return {
        success: false,
        message: '文章不存在'
      };
    },

    createPost: async (postData) => {
      await this.delay(500);
      const data = this.getData();
      
      if (!data.posts) data.posts = [];
      
      const newPost = {
        id: Date.now(),
        ...postData,
        views: 0,
        likes: 0,
        comments: 0,
        publishDate: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      };
      
      data.posts.unshift(newPost);
      this.saveData(data);
      
      return {
        success: true,
        data: newPost,
        message: '文章发布成功'
      };
    },

    updatePost: async (id, updates) => {
      await this.delay(400);
      const data = this.getData();
      const index = data.posts?.findIndex(p => p.id === parseInt(id));
      
      if (index > -1) {
        data.posts[index] = {
          ...data.posts[index],
          ...updates,
          updatedAt: new Date().toISOString()
        };
        this.saveData(data);
        
        return {
          success: true,
          data: data.posts[index],
          message: '文章更新成功'
        };
      }
      
      return {
        success: false,
        message: '文章不存在'
      };
    },

    deletePost: async (id) => {
      await this.delay(300);
      const data = this.getData();
      const initialLength = data.posts?.length || 0;
      
      data.posts = data.posts?.filter(p => p.id !== parseInt(id)) || [];
      
      if (data.posts.length < initialLength) {
        // 同时删除相关评论、点赞和收藏
        data.comments = data.comments?.filter(c => c.postId !== parseInt(id)) || [];
        data.likes = data.likes?.filter(l => l.postId !== parseInt(id)) || [];
        data.bookmarks = data.bookmarks?.filter(b => b.postId !== parseInt(id)) || [];
        
        this.saveData(data);
        
        return {
          success: true,
          message: '文章删除成功'
        };
      }
      
      return {
        success: false,
        message: '文章不存在'
      };
    },

    getUser: async (userId = 1) => {
      await this.delay(200);
      const data = this.getData();
      const user = data.users?.find(u => u.id === userId);
      
      if (user) {
        const userPosts = data.posts?.filter(p => p.authorId === userId) || [];
        
        return {
          success: true,
          data: {
            ...user,
            posts: userPosts
          }
        };
      }
      
      return {
        success: false,
        message: '用户不存在'
      };
    },

    // 互动相关
    likePost: async (postId, userId = 1) => {
      await this.delay(200);
      const data = this.getData();
      const post = data.posts?.find(p => p.id === parseInt(postId));
      
      if (post) {
        if (!data.likes) data.likes = [];
        
        const likeIndex = data.likes.findIndex(l => 
          l.postId === parseInt(postId) && l.userId === userId
        );
        
        if (likeIndex === -1) {
          // 点赞
          data.likes.push({
            id: Date.now(),
            postId: parseInt(postId),
            userId,
            createdAt: new Date().toISOString()
          });
          post.likes = (post.likes || 0) + 1;
        } else {
          // 取消点赞
          data.likes.splice(likeIndex, 1);
          post.likes = Math.max(0, (post.likes || 0) - 1);
        }
        
        this.saveData(data);
        
        return {
          success: true,
          data: { likes: post.likes },
          liked: likeIndex === -1
        };
      }
      
      return {
        success: false,
        message: '文章不存在'
      };
    },

    bookmarkPost: async (postId, userId = 1) => {
      await this.delay(200);
      const data = this.getData();
      
      if (!data.bookmarks) data.bookmarks = [];
      
      const bookmarkIndex = data.bookmarks.findIndex(b => 
        b.postId === parseInt(postId) && b.userId === userId
      );
      
      let bookmarked = false;
      
      if (bookmarkIndex === -1) {
        // 收藏
        data.bookmarks.push({
          id: Date.now(),
          postId: parseInt(postId),
          userId,
          createdAt: new Date().toISOString()
        });
        bookmarked = true;
      } else {
        // 取消收藏
        data.bookmarks.splice(bookmarkIndex, 1);
        bookmarked = false;
      }
      
      this.saveData(data);
      
      return {
        success: true,
        data: { bookmarked }
      };
    },

    submitComment: async (postId, commentData, userId = 1) => {
      await this.delay(300);
      const data = this.getData();
      const user = data.users?.find(u => u.id === userId);
      const post = data.posts?.find(p => p.id === parseInt(postId));
      
      if (!post) {
        return {
          success: false,
          message: '文章不存在'
        };
      }
      
      if (!data.comments) data.comments = [];
      
      const newComment = {
        id: Date.now(),
        postId: parseInt(postId),
        userId,
        user: {
          id: user.id,
          name: user.name,
          avatar: user.avatar
        },
        content: commentData.content,
        likes: 0,
        createdAt: new Date().toISOString()
      };
      
      data.comments.unshift(newComment);
      post.comments = (post.comments || 0) + 1;
      
      this.saveData(data);
      
      return {
        success: true,
        data: newComment
      };
    },

    getComments: async (postId) => {
      await this.delay(200);
      const data = this.getData();
      const comments = data.comments
        ?.filter(c => c.postId === parseInt(postId))
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) || [];
      
      return {
        success: true,
        data: comments
      };
    },

    // 分类和标签
    getCategories: async () => {
      await this.delay(100);
      const data = this.getData();
      const categories = [...new Set(data.posts?.map(post => post.category) || [])];
      
      const categoriesWithCount = categories.map(category => ({
        name: category,
        count: data.posts?.filter(post => post.category === category).length || 0,
        emoji: this.getCategoryEmoji(category)
      }));
      
      return {
        success: true,
        data: categoriesWithCount
      };
    },

    getPopularTags: async () => {
      await this.delay(100);
      const data = this.getData();
      const tagCounts = {};
      
      data.posts?.forEach(post => {
        post.tags?.forEach(tag => {
          tagCounts[tag] = (tagCounts[tag] || 0) + 1;
        });
      });
      
      const tags = Object.entries(tagCounts)
        .sort(([, a], [, b]) => b - a)
        .slice(0, 10)
        .map(([name, count]) => ({ name, count }));
      
      return {
        success: true,
        data: tags
      };
    },

    // 搜索
    searchPosts: async (query) => {
      await this.delay(400);
      const data = this.getData();
      const searchTerm = query.toLowerCase();
      
      const results = data.posts?.filter(post => 
        post.title.toLowerCase().includes(searchTerm) ||
        post.excerpt.toLowerCase().includes(searchTerm) ||
        post.content.toLowerCase().includes(searchTerm) ||
        post.tags?.some(tag => tag.toLowerCase().includes(searchTerm)) ||
        post.category.toLowerCase().includes(searchTerm)
      ) || [];
      
      return {
        success: true,
        data: results,
        total: results.length
      };
    },

    // 归档
    getArchives: async () => {
      await this.delay(300);
      const data = this.getData();
      const posts = data.posts || [];
      
      const archives = {};
      posts.forEach(post => {
        try {
          const date = new Date(post.publishDate);
          const year = date.getFullYear();
          const month = date.getMonth() + 1;
          const key = `${year}年${month}月`;
          
          if (!archives[key]) {
            archives[key] = {
              year,
              month,
              display: key,
              count: 0,
              posts: []
            };
          }
          archives[key].count += 1;
          archives[key].posts.push(post);
        } catch (error) {
          console.error('处理文章日期错误:', error);
        }
      });
      
      const archivesArray = Object.values(archives)
        .sort((a, b) => {
          if (a.year !== b.year) return b.year - a.year;
          return b.month - a.month;
        });
      
      return {
        success: true,
        data: archivesArray
      };
    },

    // 热门文章
    getPopularPosts: async (params = {}) => {
      await this.delay(200);
      const data = this.getData();
      let posts = [...(data.posts || [])];
      
      posts.sort((a, b) => (b.views || 0) - (a.views || 0));
      
      const limit = params.limit || 5;
      const popularPosts = posts.slice(0, limit);
      
      return {
        success: true,
        data: popularPosts
      };
    },

    // 网站配置
    getSiteConfig: async () => {
      await this.delay(150);
      const data = this.getData();
      
      return {
        success: true,
        data: data.siteConfig || this.generateSiteConfig()
      };
    },

    updateSiteConfig: async (updates) => {
      await this.delay(300);
      const data = this.getData();
      
      data.siteConfig = {
        ...data.siteConfig,
        ...updates,
        updatedAt: new Date().toISOString()
      };
      
      this.saveData(data);
      
      return {
        success: true,
        data: data.siteConfig
      };
    },
    
    getAboutPage: async () => {
      await this.delay(300);
      
      return {
        success: true,
        data: {
          title: '关于喵星人日记',
          subtitle: '记录与猫咪共度的美好时光',
          content: `
            <h2>🐱 关于我们</h2>
            <p>喵星人日记是一个专注于猫咪生活、养护、健康和趣事的社区平台。我们致力于为所有猫奴提供一个分享经验、交流心得、记录美好时刻的空间。</p>
            
            <h2>🎯 我们的使命</h2>
            <ul>
              <li>💖 分享科学的猫咪养护知识</li>
              <li>📝 记录与猫咪的点滴故事</li>
              <li>🤝 连接热爱猫咪的朋友们</li>
              <li>🐾 推广猫咪健康生活方式</li>
            </ul>
            
            <h2>👥 团队成员</h2>
            <div class="team-members">
              <div class="team-member">
                <h3>🐈 猫咪守护者</h3>
                <p>资深猫奴，家有3只喵星人，热爱分享猫咪知识</p>
              </div>
              <div class="team-member">
                <h3>👨‍⚕️ 猫博士</h3>
                <p>宠物医生，专注于猫咪健康管理和疾病预防</p>
              </div>
              <div class="team-member">
                <h3>🎨 猫画家</h3>
                <p>插画师，用画笔记录猫咪的可爱瞬间</p>
              </div>
            </div>
            
            <h2>📈 发展历程</h2>
            <ul>
              <li><strong>2023年1月</strong> - 项目启动，初代版本上线</li>
              <li><strong>2023年6月</strong> - 用户突破1000人</li>
              <li><strong>2023年12月</strong> - 文章数量突破500篇</li>
              <li><strong>2024年3月</strong> - 全新改版，功能全面升级</li>
            </ul>
            
            <h2>📞 联系我们</h2>
            <p>电话：13676249448</p>
          `,
          stats: {
            users: 1289,
            posts: 543,
            comments: 2341,
            likes: 15678
          },
          socialLinks: {
            weibo: 'https://weibo.com/catdiary',
            github: 'https://github.com/catdiary',
            bilibili: 'https://space.bilibili.com/catdiary'
          },
          updatedAt: '2024-03-20'
        }
      };
    },

    // 统计数据
    getStatistics: async () => {
      await this.delay(250);
      const data = this.getData();
      
      return {
        success: true,
        data: {
          totalPosts: data.posts?.length || 0,
          totalComments: data.comments?.length || 0,
          totalUsers: data.users?.length || 0,
          totalLikes: data.likes?.length || 0,
          totalBookmarks: data.bookmarks?.length || 0
        }
      };
    },

    // =============== 新增的图片上传相关方法 ===============

    // 图片上传（模拟）
    uploadImage: async (file, type = 'cover') => {
      await this.delay(1500);
      
      // 这里模拟图片上传过程
      // 在实际应用中，这里应该将文件上传到服务器并返回URL
      // 我们使用固定的图片链接来模拟
      
      const catImages = [
        'https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba?w=800&auto=format&fit=crop',
        'https://images.unsplash.com/photo-1574144113084-b6f8a69f5b39?w=800&auto=format&fit=crop',
        'https://images.unsplash.com/photo-1592194996308-7b4388988558?w=800&auto=format&fit=crop',
        'https://images.unsplash.com/photo-1551269901-5c5e14c25df7?w=800&auto=format&fit=crop',
        'https://images.unsplash.com/photo-1548247416-ec66f4900b2e?w=800&auto=format&fit=crop'
      ];
      
      const avatarImages = [
        'https://images.unsplash.com/photo-1561948955-570b270e7c36?w=200&h=200&fit=crop&crop=face',
        'https://images.unsplash.com/photo-1533738363-b7f9aef128ce?w=200&h=200&fit=crop&crop=face',
        'https://images.unsplash.com/photo-1519058082700-08a0b56da9b4?w=200&h=200&fit=crop&crop=face',
        'https://images.unsplash.com/photo-1526336024174-e58f5cdd8e13?w=200&h=200&fit=crop&crop=face'
      ];
      
      const coverImages = [
        'https://images.unsplash.com/photo-1513360371669-4adf3dd7dff8?w=1200&h=300&fit=crop',
        'https://images.unsplash.com/photo-1543852786-1cf6624b9987?w=1200&h=300&fit=crop',
        'https://images.unsplash.com/photo-1533743983669-94fa5c4338ec?w=1200&h=300&fit=crop',
        'https://images.unsplash.com/photo-1514888286974-6d03bde4ba48?w=1200&h=300&fit=crop'
      ];
      
      // 根据上传类型返回不同的图片
      let imageUrl;
      if (type === 'avatar') {
        imageUrl = avatarImages[Math.floor(Math.random() * avatarImages.length)];
      } else if (type === 'cover') {
        imageUrl = coverImages[Math.floor(Math.random() * coverImages.length)];
      } else {
        imageUrl = catImages[Math.floor(Math.random() * catImages.length)];
      }
      
      // 模拟生成文件名
      const fileName = file ? file.name : `image_${Date.now()}.jpg`;
      const fileSize = file ? (file.size / 1024 / 1024).toFixed(2) : '1.5';
      
      return {
        success: true,
        data: {
          url: imageUrl,
          fileName: fileName,
          fileSize: fileSize + ' MB',
          uploadedAt: new Date().toISOString(),
          type: type
        },
        message: '图片上传成功'
      };
    },

    // 更新用户头像
    updateUserAvatar: async (userId, avatarUrl) => {
      await this.delay(800);
      const data = this.getData();
      const userIndex = data.users?.findIndex(u => u.id === userId);
      
      if (userIndex > -1) {
        data.users[userIndex].avatar = avatarUrl;
        this.saveData(data);
        
        return {
          success: true,
          data: data.users[userIndex],
          message: '头像更新成功'
        };
      }
      
      return {
        success: false,
        message: '用户不存在'
      };
    },

    // 更新用户封面
    updateUserCover: async (userId, coverUrl) => {
      await this.delay(800);
      const data = this.getData();
      const userIndex = data.users?.findIndex(u => u.id === userId);
      
      if (userIndex > -1) {
        data.users[userIndex].coverImage = coverUrl;
        this.saveData(data);
        
        return {
          success: true,
          data: data.users[userIndex],
          message: '封面更新成功'
        };
      }
      
      return {
        success: false,
        message: '用户不存在'
      };
    },

    // 更新用户信息
    updateUser: async (userId, updates) => {
      await this.delay(1000);
      const data = this.getData();
      const userIndex = data.users?.findIndex(u => u.id === userId);
      
      if (userIndex > -1) {
        data.users[userIndex] = {
          ...data.users[userIndex],
          ...updates,
          updatedAt: new Date().toISOString()
        };
        
        this.saveData(data);
        
        return {
          success: true,
          data: data.users[userIndex],
          message: '用户信息更新成功'
        };
      }
      
      return {
        success: false,
        message: '用户不存在'
      };
    }
  };
}

const virtualBackend = new VirtualBackend();

export const api = virtualBackend.api;